import { action, computed, observable, makeObservable } from 'mobx';
import { isFullSession, SessionIndexView } from '../../../../types/sessions';
import { SessionId } from '../../../../../commonv3/types/sessions';
import { SessionWaitlistId } from '../../../../../commonv3/types/sessionWaitlists';
import { SessionWaitlistsApis } from '../../../../apis/session_waitlists';
import { RemoteResourceV3, updateRemoteResourceV3 } from '../../../../../commonv3/api/RemoteResourceV3';
import { SessionWaitlistIndexView } from '../../../../types/sessionWaitlists';
import moment from 'moment-timezone';

export class SessionWaitlistState {
  sessionWaitlists: RemoteResourceV3<SessionWaitlistIndexView[]> = RemoteResourceV3.loading();
  submitting = false;

  constructor() {
    makeObservable(this, {
      sessionWaitlists: observable,
      submitting: observable,
      init: action.bound,
      loading: computed,
      reloadSessionWaitlists: action.bound,
      canShowWaitlist: action.bound,
      createSessionWaitingList: action.bound,
      cancelSessionWaitingList: action.bound,
    });
  }

  async init() {
    await this.reloadSessionWaitlists();
  }

  get loading() {
    return this.sessionWaitlists.loading;
  }

  async reloadSessionWaitlists() {
    await updateRemoteResourceV3(
      this.sessionWaitlists,
      (v) => (this.sessionWaitlists = v),
      () => SessionWaitlistsApis.findAll()
    );
  }

  overDeadlineCreateWaitlist(entry: SessionIndexView) {
    return moment(entry.starts_at).hour(8).minute(0).second(0).isBefore(moment());
  }

  canShowWaitlist(entry: SessionIndexView, reserved: boolean) {
    return isFullSession(entry) && !reserved && !this.overDeadlineCreateWaitlist(entry);
  }

  async createSessionWaitingList(sessionId: SessionId) {
    try {
      this.submitting = true;
      await SessionWaitlistsApis.create(sessionId);
      this.reloadSessionWaitlists();
    } finally {
      this.submitting = false;
    }
  }

  async cancelSessionWaitingList(sessionWaitlistId: SessionWaitlistId) {
    try {
      this.submitting = true;
      await SessionWaitlistsApis.cancel(sessionWaitlistId);
      this.reloadSessionWaitlists();
    } finally {
      this.submitting = false;
    }
  }
}
